<template>
  <v-card flat class="ma-0 pa-0" color="transparent">
    <v-card-text v-if="!invisible" class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">タグ</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark rounded depressed small color="error" @click.native="onAdd()">
              <span class="text-none">追加</span>
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="1" class="pa-0" align="center"></v-col>
          <v-col cols="11" class="pa-0">
            <v-row class="ma-0 py-0" align="center">
              <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                <v-row align="center" justify="center" style="height:48px;">
                  <template v-for="(header, index) in headers">
                    <v-col :cols="header.width"  :align="header.align" class="pa-0" :key="header.key">
                      <template v-if="header.valid">
                        <v-sheet class="pa-0 customHeader" color="transparent">
                          <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                          <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                        </v-sheet>
                      </template>
                      <template v-else>
                        <span>{{ header.title }}</span>
                      </template>
                    </v-col>
                  </template>
                  <v-col class="pa-0" align="center">
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto'>
                  <RecycleScroller
                    class="scroller"
                    :items="filterItems"
                    :item-size="44"
                    key-field="key"
                  >
                    <template v-slot="{ item, index }">
                      <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                        <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;" @click.stop="onSelect(item)">
                          <template v-for="(header) in headers">
                            <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                              <template v-if="header.key == 'delete'">
                                <v-btn icon @click.stop.prevent="onDeleteDialog(item)">
                                  <v-icon color="error">mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <template v-else-if="header.key == 'color'">
                                <v-icon :color="item.color">mdi-tag</v-icon>
                              </template>
                              <template v-else>
                                <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                                  <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                </v-col>
                              </template>
                            </v-col>
                          </template>
                        </v-row>
                      </v-sheet>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>
    <template v-else>
      <v-btn dark icon rounded depressed small color="primary" @click.native="onAdd()"><v-icon>mdi-tag-plus</v-icon></v-btn>
    </template>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0">
          <v-dialog
            v-model='addDialog'
            persistent
            max-width="400px">
            <v-card v-if="addDialog" flat>
              <v-card-title class="title white--text" :style="item.color ? 'background-color: ' + item.color : 'primary'">
                <v-icon class="white--text px-1">mdi-tag</v-icon>
                <span>タグ</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="12" class="pa-0">
                    <v-text-field
                      ref="name"
                      v-model="item.name"
                      label="名称"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-0 pt-0" align="center">
                    <v-color-picker show-swatches hide-canvas hide-mode-switch hide-inputs swatches-max-height="230px" :swatches="swatches" v-model="item.color"></v-color-picker>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed rounded @click.native="addDialog = false">取消</v-btn>
                <v-btn depressed rounded color="primary" @click="onStore()">{{ item.key ? '変更' : '作成' }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <div>
      <app-basic-dialog
        v-if="deleteDialog"
        @dismissed="onDismissed"
        title='削除'
        :message="deleteItem.name + ' を削除します。よろしいですか?'"
        :dialog='deleteDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TemplateScholaeDialog from './TemplateScholaeDialog.vue'
Vue.component('template-tags-dialog', TemplateScholaeDialog)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      tags: 'tags/tags',
      windowSize: 'shared/windowSize'
    }),
    filterItems () {
      var temp = []
      for (var i in this.tags) {
        if (this.tags[i].schools[this.mySchool.key]) {
          temp.push(JSON.parse(JSON.stringify(this.tags[i])))
        }
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    mySchool () {
      if (this.school) {
        return JSON.parse(JSON.stringify(this.school))
      } else {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(s => s.key === keys[i])
            if (index !== -1) {
              return JSON.parse(JSON.stringify(this.schools[index]))
            }
          }
        }
      }
      return null
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    },
    swatches () {
      return [
        ['#F44336', '#E91E63', '#9C27B0'],
        ['#673AB7', '#3F51B5', '#2196F3'],
        ['#03A9F4', '#00BCD4', '#009688'],
        ['#4CAF50', '#8BC34A', '#CDDC39'],
        ['#FFEB3B', '#FFC107', '#FF9800'],
        ['#FF5722', '#795548', '#607D8B'],
        ['#9E9E9E', '#616161', '#000000']
      ]
    }
  },
  data () {
    return {
      headers: [
        { valid: false, over: false, value: 0, title: '', key: 'color', width: '1', align: 'center' },
        { valid: true, over: false, value: 2, title: '名称', key: 'name', width: '10', align: 'start' },
        { valid: false, over: false, value: 2, title: '', key: 'delete', width: '1', align: 'end' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      addDialog: false,
      deleteDialog: false,
      deleteItem: null,
      loading: false,
      item: null,
      rules: {
        required: value => !!value || '必須'
      }
    }
  },
  props: [ 'type', 'school', 'invisible' ],
  methods: {
    onClose () {
      this.$emit('dismissed')
    },
    onAdd () {
      this.item = JSON.parse(JSON.stringify(this.$store.getters['tags/initial']))
      var v = {}
      v[this.mySchool.key] = true
      this.item.schools = v
      this.item.category = 'task'
      this.addDialog = true
    },
    onSelect (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.addDialog = true
    },
    onDeleteDialog (item) {
      this.deleteItem = item
      this.deleteDialog = true
    },
    onDelete () {
      var vm = this
      this.loading = true
      this.$store.dispatch('tags/delete', JSON.parse(JSON.stringify(this.deleteItem.key))).then(() => {
        vm.loading = false
        vm.deleteDialog = false
        vm.item = null
      })
    },
    onStore () {
      var vm = this
      if (this.$refs.name.validate(true)) {
        vm.loading = true
        var payload = JSON.parse(JSON.stringify(this.item))
        payload['updatedAt'] = parseInt(new Date().getTime())
        if (!payload.key) {
          payload['createdAt'] = parseInt(new Date().getTime())
        }
        this.$store.dispatch('tags/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.item = null
          vm.loading = false
          vm.addDialog = false
          vm.$emit('added', resp)
        })
      }
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onDismissed: function (value) {
      if (this.deleteDialog) {
        this.deleteDialog = false
        if (value) {
          this.onDelete()
        }
        return
      }
      this.addDialog = false
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  line-height: 48px;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
